import { render, staticRenderFns } from "./App.vue?vue&type=template&id=814b5e56&scoped=true"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=814b5e56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814b5e56",
  null
  
)

export default component.exports